import { isObjectRecord, isOperation } from "../../typeGuards";
import { ArsTableOperation } from "../interface";

/**
 * Type guard for ArsTableOperation, which is a possible type of ArsTableGroup.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the operation label
 * @returns - True if the object is an ArsTableOperation, false otherwise
 */
export const isArsTableOperation = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T = (val: unknown): val is T => typeof val === "string",
): obj is ArsTableOperation<T> => {
  // Check object
  if (!isObjectRecord(obj)) return false;

  // Check required properties
  if (typeof obj.id !== "string") return false;
  if (!["number", "undefined"].includes(typeof obj.decimalAlignPercentage)) return false;
  if (!["number", "undefined"].includes(typeof obj.dimension)) return false;
  if (!["boolean", "undefined"].includes(typeof obj.hidden)) return false;
  if (!isT(obj.label)) return false;
  if (!isOperation(obj.operation)) return false;

  // Everything is good
  return true;
};
